import React from 'react';

export default props => (
	<div className="LOGIN">
		<div className="primary-action">
			<button className="button" onClick={() => props.handleLogin()}>LOGIN</button>
		</div>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/login-panel.js